import React from "react";

const AccountSettings = ({
    onOpenPersonalInformation,
    onOpenSecurity,
    onOpenDeleteAccount,
}) => {
    return (
        <div className="settings-list">

            <div
                className="settings-item"
                onClick={onOpenPersonalInformation}
            >
                <p>Personal Information</p>

                <span>
                    <i className="fas fa-chevron-right" />
                </span>
            </div>

            <div
                className="settings-item"
                onClick={onOpenSecurity}
            >
                <p>Security</p>

                <span>
                    <i className="fas fa-chevron-right" />
                </span>
            </div>

            <div
                className="settings-item"
                onClick={onOpenDeleteAccount}
            >
                <p>Delete / Deactivate Account</p>

                <span>
                    <i className="fas fa-chevron-right" />
                </span>
            </div>

        </div>
    );
};

export default AccountSettings;